export default "__VITE_ASSET__CZQiHI9b__"